<template>
  <div class="segment">
    <h1>Joey Haddad - 2019 / 2020 Season</h1>
    <p> All Situations - Goals SOT Shifts</p>
    <p> EH - Shot+/-</p>
      <apex-chart type="line" height=350 :series="chartData" :options="options" ref="test"></apex-chart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'
export default {
  components: {
    'apex-chart': VueApexCharts
  },
  data () {
    return {
      url: 'https://devilsapi.roblutken.com/api/season-stats/realtime-test',
      realtimeData: [],
      timer: '',
      index: 0,
      tagData: [{
        event: 'test',
        count: 100
      },
      {
        event: 'test2',
        count: 50
      }
      ],
      series: [{
        name: 'Shifts',
        data: []
      },
      {
        name: 'Goals',
        data: []
      },
      {
        name: 'SOT',
        data: []
      },
      {
        name: 'SHOT+/-',
        data: []
      }],
      data: [],
      options: {
        chart: {
          title: 'Shifts / Time',
          align: 'left',
          type: 'line',
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 900
            }
          }
        },
        labels: [],
        toolbar: { show: false },
        zoom: { enabled: false },
        stroke: { curve: 'smooth' },
        xaxis: {
        },
        yaxis: {
        }
      }
    }
  },
  computed: {
    chartData: function () {
      this.series[0].data = _.slice(this.realtimeData, 0, 5)
      return this.series
    }
  },
  methods: {
    updateSeries () {
      this.series[0].data = []
      this.series[1].data = []
      this.series[2].data = []
      this.series[3].data = []
      if (this.index++ <= this.realtimeData.length) {
        console.log(this.index + ' ' + JSON.stringify(_.slice(this.realtimeData, 0, this.index)))
        for (var d of _.slice(this.realtimeData, 0, this.index)) {
          let event = d.match_date + d.vs_team
          this.series[0].data.push({x: event, y: d.shifts})
          this.series[1].data.push({x: event, y: d.goals})
          this.series[2].data.push({x: event, y: d.shots})
          this.series[3].data.push({x: event, y: d.corsi_diff})
        }
        this.$refs.test.updateSeries([{
          data: this.series[0].data
        },
        {
          data: this.series[1].data
        },
        {
          data: this.series[2].data
        },
        {
          data: this.series[3].data
        }])
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  mounted () {
    this.$http
    .post(this.url, [], {
      headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
    })
    .then(
      response => {
        console.log('response was: ' + JSON.stringify(response.data))
        this.realtimeData = response.data
      },
      response => {}
    )
    this.timer = setInterval(this.updateSeries, 900)
    // console.log('Test is : ' + this.$refs.test)
  }
}
</script>

<style lang='scss' scoped>

.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// apex-realtime.vue?0a63c692